<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-brand">
        <i class="el-icon-menu" />
        <h1>卡密系统</h1>
        <p class="sub">管理后台登录</p>
      </div>
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-position="top"
        class="login-form"
        @submit.native.prevent="onSubmit"
      >
        <el-form-item label="账号" prop="username">
          <el-input
            v-model="form.username"
            placeholder="请输入账号"
            prefix-icon="el-icon-user"
            clearable
            @keyup.enter.native="onSubmit"
          />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
            clearable
            @keyup.enter.native="onSubmit"
          />
        </el-form-item>
        <el-form-item class="login-actions">
          <el-button
            class="btn-black login-btn"
            type="primary"
            :loading="loading"
            native-type="submit"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { login } from '@/utils/auth'
import { loginApi } from '@/api/login'

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        try {
          const data = await loginApi({
            username: this.form.username,
            password: this.form.password
          })
          login(this.form.username, data.token)
          const redirect = this.$route.query.redirect
          const path =
            typeof redirect === 'string' && redirect.startsWith('/') && !redirect.startsWith('//')
              ? redirect
              : '/card-secret'
          this.$router.replace(path).catch(() => {})
        } catch {
          // 错误已在 request.js 响应拦截器中统一处理
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #e8ecf1 0%, #f5f7fa 45%, #eef2f6 100%);
  padding: 24px;
}

.login-card {
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 12px;
  padding: 36px 40px 28px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.login-brand {
  text-align: center;
  margin-bottom: 28px;
}

.login-brand i {
  font-size: 40px;
  color: #303133;
}

.login-brand h1 {
  margin: 12px 0 6px;
  font-size: 24px;
  font-weight: 600;
  color: #303133;
}

.sub {
  margin: 0;
  font-size: 14px;
  color: #909399;
}

.login-form >>> .el-form-item__label {
  padding-bottom: 4px;
  line-height: 1.3;
}

.login-actions {
  margin-bottom: 0;
  margin-top: 8px;
}

.login-btn {
  width: 100%;
  padding: 12px 20px;
  font-size: 15px;
}

.login-hint {
  margin: 20px 0 0;
  text-align: center;
  font-size: 12px;
  color: #c0c4cc;
}
</style>
